module.exports = __webpack_public_path__ + "img/helpdetail5.296c1d59.png";